<template>
  <div class="overflowTop">
    <div class="detailsInfo2">
      <div class="infoTop">
        <ul>
          <li class="li_20">
            <img v-if="customerInfo.headImgUrl" :src="customerInfo.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120'" />
            <div v-else class="noImg">
              <i class="iconfont">&#xe719;</i>
            </div>
            <h1>
              {{ customerInfo.nickName }}
              <i class="el-icon-edit" style="cursor: pointer;" @click="edit()" />
            </h1>
            <h2>
              {{ customerInfo.phone ? Lib.starPhone(customerInfo.phone) : '--' }}
            </h2>
            <h2>
              <samp v-if="customerInfo.distributeType!=0&&customerInfo.distributeType">{{ customerInfo.distributeType===2 ? '分销员' : customerInfo.distributeType==1 ? '已绑定分销员' : '' }}</samp>
              <samp v-if="customerInfo.distributorType == 1">经销商</samp>
            </h2>
          </li>
          <li v-if="customerInfo.cardNo" class="li_20">
            <h3>
              <span>会员等级：</span>
              <samp>{{ customerInfo.gradeName || '--' }} </samp>
              <samp style="margin-left:5px;"> {{ customerInfo.discount ? ('('+customerInfo.discount+'折)') : '--' }} </samp>
            </h3>
            <h3>
              <span>会员卡号：</span>
              <samp class="themeFC" style="cursor: pointer;" @click="customerInfo.cardNo ? openMemberDetails(customerInfo.phone,customerInfo.memberId) : ''">{{ customerInfo.cardNo || '--' }}</samp>
            </h3>
          </li>
          <li v-if="customerInfo.cardNo" class="li_20">
            <h3>
              <span>会员余额：</span>
              <samp>¥{{ customerInfo.money || '0.00' }}</samp>
              <span style="cursor: pointer;margin-left:5px;" class="themeFC" @click="newGetMemberUrl(1)"> 充值 </span>
            </h3>
            <h3>
              <span>会员积分：</span>
              <samp>{{ customerInfo.integral || '0' }}</samp>
            </h3>
          </li>
          <li v-if="customerInfo.cardNo" class="li_20">
            <h3>
              <span>可用优惠券：</span>
              <samp><span style="cursor: pointer;" class="themeFC" @click="customerInfo.couponCount>0?newGetMemberUrl(3):''"> {{ customerInfo.couponCount || '0' }} </span>张</samp>
            </h3>
            <h3>
              <span>货款余额：</span>
              <samp>¥{{ customerInfo.loanBalance||'0.00' }}</samp>
            </h3>
          </li>

          <li class="li_10">
            <p v-if="customerInfo.distributionMsgUrl">
              <yz-btn type="primary" @click="newGetMemberUrl(2)">分销员详情</yz-btn>
            </p>
            <p v-if="customerInfo.distributorMsgUrl">
              <yz-btn type="primary" @click="newGetMemberUrl(4)">经销商详情</yz-btn>
            </p>
          </li>
        </ul>
      </div>

      <div class="infoBottom">
        <h4>
          <el-tooltip class="item" effect="dark" content="消费总次数，金额，时间，只统计了客户在当前门店的消费数据" placement="top-start">
            <i class="el-icon-warning"></i>
          </el-tooltip>
          消费总次数：
          <samp>{{ customerInfo.expenseCount || '0' }}</samp>
          次
        </h4>
        <h5>
          消费总金额：
          <!-- class="themeFC" -->
          <samp>￥</samp>
          <span>{{ customerInfo.expenseTotal || '0.00' }}</span>
        </h5>
        <h4>
          最近消费时间：{{ customerInfo.lastTime }}
        </h4>
        <yz-btn v-if="Lib.checkPower('beauty-3-scgkxx',2)" style="float: right;margin: 16px 0 16px 10px;" @click="delCustomer(customerInfo)">删除</yz-btn>
        <yz-btn v-if="!customerInfo.cardNo" type="primary" style="float: right;margin: 16px 0 16px 10px;" @click="newGetMemberUrl(0)">办理会员</yz-btn>
        <yz-btn v-if="Lib.checkPower('beauty-2-gkkd')" type="primary" style="float: right;margin: 16px 0;" @click="createOrder(customerInfo.phone,customerInfo.memberName)">开单</yz-btn>
      </div>
    </div>

    <el-dialog class="memberDialog" :title="memberDiaStatus == 1 ? '会员充值' : memberDiaStatus == 2 ? '分销员详情' : memberDiaStatus == 3 ? '可用优惠券详情' : memberDiaStatus == 4 ?'经销商详情':'新增会员'" :visible.sync="memberDialog" :append-to-body="true">
      <iframe :src="memberManageSrc"></iframe>
    </el-dialog>
    <gt-delDig @delData="getDelData"></gt-delDig>
    <el-tabs v-model="activeName">
      <el-tab-pane label="基础信息" name="customer-info">
        <customerInfo :customer-info="customerInfo"></customerInfo>
      </el-tab-pane>
      <el-tab-pane label="顾客套餐" name="customer-package">
      </el-tab-pane>
      <el-tab-pane label="赠品记录" name="customer-gift">
      </el-tab-pane>
      <el-tab-pane label="预约记录" name="customer-bespeak">
      </el-tab-pane>
      <el-tab-pane label="消费记录" name="customer-consume">
      </el-tab-pane>
      <!-- <el-tab-pane label="套餐划扣记录" name="customer-recharge">
            </el-tab-pane> -->
      <el-tab-pane label="房间记录" name="customer-record">
      </el-tab-pane>
    </el-tabs>
    <keep-alive v-if="activeName != 'customer-info'">
      <router-view></router-view>
    </keep-alive>
    <customerDialog v-if="customerVisible" :customer-visible="customerVisible" :title="'编辑顾客'" @close="onCloseDialog" />
  </div>
</template>

<script>
import { getOneCustomerMsg, getMemberUrl } from './api';
import customerDialog from '../customer_detail';
import customerInfo from './template/info';

export default {
  components: {
    customerDialog,
    customerInfo
  },
  data() {
    return {
      phone: '', // 顾客手机号码
      activeName: 'customer-info', // tab指定位置
      customerInfo: {}, // 顾客信息数据
      // 4.7.0
      customerVisible: false, // 顾客编辑弹窗
      // 5.4
      memberDialog: false, // 注册会员弹窗
      memberManageSrc: '', // 注册会员地址
      memberDiaStatus: '',
      delForm: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'deleteOrder',
        text1: '',
        text2: '',
        status: false
      },
    };
  },
  watch: {
    $route(e) {
      this.activeName = e.name;
    },
    activeName() {
      this.$router.push({
        name: this.activeName
      });
    },
    customerVisible(val) {
      if (val == false) this.getCustomerMsg();
    },
    'delForm.status': function (val) {
      if (val == true) {
        this.$store.commit('deleteTabs', 'customer-info');
        this.$router.replace({
          name: 'customer-index'
        });
      }
    },
    memberDialog(val) {
      if (val == false && (this.memberDiaStatus == 1 || this.memberDiaStatus == 0)) {
        this.getCustomerMsg();
      }
    }
  },
  mounted() {
    this.$router.push({
      name: this.activeName
    });
  },
  activated() {
    this.phone = window.sessionStorage.customerPhone;
    this.activeName = this.$route.params.name ? this.$route.params.name : 'customer-info';
    this.getCustomerMsg();
  },
  methods: {
    // 打开会员详情页面
    openMemberDetails(phone, memberId) {
      window.sessionStorage.memberPhone = phone;
      window.sessionStorage.memberId = memberId;
      this.$router.push({
        name: 'customer-member'
      });
    },
    // 开单事件
    createOrder(phone, name) {
      if (this.Lib.checkPower('beauty-2-gkkd') == false) return;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.userName = name;
      window.sessionStorage.userPhone = phone;
      window.sessionStorage.bookOrderId = '';
      this.$router.push({
        name: 'stage-serviceBilling'
      });
    },
    // 调用公共组件--赋值--5.9
    getDelData(list) {
      console.log(list);
      this.delForm = list;
    },
    // 删除顾客
    delCustomer(info) {
      if (info.deleteStatus == 1) {
        this.delForm.delDiglogStatus = true;
        this.delForm.id = info.phone;
        this.delForm.title = '提示';
        this.delForm.url = 'deleteCustomer';
        this.delForm.text1 = '是否要删除该顾客信息？';
        this.delForm.text2 = '删除后数据不可恢复，请谨慎删除！';
        this.delForm.status = false;
      } else if (info.deleteStatus == -1) {
        this.$message({ message: '非创建顾客的门店不可删除！', type: 'warning' });
      } else if (info.deleteStatus == -2) {
        this.$message({ message: '该顾客已有使用记录，不可删除！', type: 'warning' });
      } else if (info.deleteStatus == -3) {
        this.$message({ message: '会员顾客不可删除！', type: 'warning' });
      }
    },
    // open 新增会员
    newGetMemberUrl(val) {
      if (val == 1) {
        if (this.Lib.checkPower('beauty-2-czhy') == false) return;
      } else if (val == 0) {
        if (this.Lib.checkPower('beauty-2-hybl2') == false) return;
      } else if (val == 3) {
        if (this.Lib.checkPower('beauty-3-ckgkyhjxx2') == false) return;
      } else if (val == 2) {
        if (this.Lib.checkPower('beauty-3-ckfxyxq2') == false) return;
      }
      this.memberDiaStatus = val;
      if (val == 2) {
        this.memberDialog = true;
        this.memberManageSrc = this.customerInfo.distributionMsgUrl;
      } else if (val == 3) {
        this.memberDialog = true;
        this.memberManageSrc = this.customerInfo.memberCouponUrl;
      } else if (val == 4) {
        this.memberDialog = true;
        this.memberManageSrc = this.customerInfo.distributorMsgUrl;
      } else {
        const data = { type: val };
        getMemberUrl(data).then((res) => {
          if (res.code == 0) {
            this.memberManageSrc = `${res.data}?phone=${this.phone}&hideBack=1&shopId=${window.sessionStorage.shopId}`;
            this.memberDialog = true;
          } else {
            console.log(res);
          // this.$message(res.msg)
          }
        });
      }
    },
    // 获取顾客信息
    getCustomerMsg() {
      const data = {
        keyWord: this.phone
      };
      getOneCustomerMsg(data).then((res) => {
        if (res.code == 0) {
          res.data.accessory = res.data.accessory || [];
          res.data.accessory = res.data.accessory.map((a) => ({
            attachment: a.url,
            fileType: a.fileType,
            fileName: this.getNameOfFile(a.url),
          }));
          this.customerInfo = res.data;
        } else {
          this.customerInfo = {};
          // console.log(res)
        }
      });
    },
    // 获取文件名称
    getNameOfFile(url) {
      const start = url.indexOf('_');
      const fileName = url.substring(start + 1, url.length);
      return fileName;
    },
    // 4.7.0編輯
    edit() {
      this.customerVisible = true;
    },
    onCloseDialog(val) {
      this.customerVisible = val;
    }
  }
};
</script>

<style lang="less" scoped>
.overflowTop {
  overflow: visible;
}
.gender {
  width: 32px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  border-radius: 4px;
  transform: scale(0.5);
  display: inline-block;
  position: relative;
  top: -2px;
}
.gender_b {
  background-color: #409eff;
}
.gender_g {
  background-color: #fd5c8c;
}
.gender_w {
  background-color: #e6a23c;
}
.noImg {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 50%;
  background-color: #fff;
  margin-right: 20px;
  float: left;
}
.noImg > i {
  font-size: 28px;
}

// 6.81新样式
.detailsInfo2{
  height: 200px;
  margin: 20px 0;
  padding: 0 30px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  .infoTop {
    padding: 20px 0;
    border-bottom: 1px solid #f5f5f5;
    ul {
      list-style: none;
      height: 100px;
      li {
        height: 70px;
        padding: 10px 0;
        float: left;
        color: #333333;
        img {
          float: left;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 20px;
          margin-top: 10px;
        }
        h1 {
          color: #333;
          font-size: 16px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        h2 {
          font-size: 16px;
          font-weight: 500;
          line-height: 35px;
          samp {
            float: left;
            font-size: 12px;
            background-color: #000;
            color: #ffc500;
            height: 19px;
            line-height: 19px;
            border-radius: 8px;
            margin-left: 5px;
            padding: 0 10px;
            position: relative;
            top: 4px;
          }
        }
        h3 {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .li_20 {
        width: 22.5%;
      }
      .li_10 {
        width: 10%;
        p{
          margin-top:10px;
        }
      }
    }
  }
  .infoBottom {
    height: 60px;
    h4 {
      width: 25%;
      white-space: nowrap;
      float: left;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
    h5 {
      width: 30%;
      white-space: nowrap;
      float: left;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
  }
}
</style>

<style scoped>
.distributPopover {
  padding: 10px;
}
.distributPopover p{
  height: 30px;
  line-height: 30px;
  color: #333;
  font-size: 14px;
}
.distributPopover p span {
  float: left;
}
.distributPopover p samp{
  float: left;
  font-size: 12px;
  background-color: #000;
  color: #ffc500;
  height: 19px;
  line-height: 19px;
  border-radius: 8px;
  margin-left: 5px;
  padding: 0 10px;
  position: relative;
  top: 4px;
}
</style>
